<template>
  <div>
    <v-sheet
      tile
      height="50"
      class="d-flex"
    >
      <v-btn
        icon
        class="ma-2"
        @click="$refs.calendar.prev()"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-select
        v-model="type"
        :items="types"
        dense
        outlined
        hide-details
        class="ma-2"
        label="type"
      ></v-select>
      <v-select
        v-model="showCategories"
        :items="categories"
        dense
        outlined
        multiple
        hide-details
        label="Categories"
        class="ma-2"
      >
      <template v-slot:selection="{ item, index }">
        <span v-if="index === 0">{{ item }}</span>
        <span
          v-if="index === 1"
          class="grey--text text-caption"
        >
          (+{{ showCategories.length -1 }} others)
        </span>
      </template>
      </v-select>
      <v-select
        v-model="weekday"
        :items="weekdays"
        dense
        outlined
        hide-details
        label="weekdays"
        class="ma-2"
      ></v-select>
      <v-spacer></v-spacer>
      <div>
        Επισκευές: {{ events.filter(e=> e.category == "Repairs").length }} -
        Τζίρος: {{ $tocurr(events.filter(e=> e.category == "Repairs").reduce((a,b) => a + (b.repair.RepairCost ||0),0)) }} -
        Kέρδος: {{ $tocurr(events.filter(e=> e.category == "Repairs"
        ).reduce((a,b) => a + (b.repair.Profit ||0),0)) }}
      </div>
      <v-btn
        icon
        class="ma-2"
        @click="$refs.calendar.next()"
      >
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-sheet>
    <v-sheet height="800">
      <v-calendar
        ref="calendar"
        v-model="value"
        :weekdays="weekday"
        :type="type"
        :categories="categories"
        :events="filteredEvents"
        event-overlap-mode="column"
        :event-overlap-threshold="30"
        :event-color="getEventColor"
        @change="getEvents"
        @click:event="showEvent"
        @click:time="intervalClick"
        @click:more="viewDay"
        @click:date="viewDay"
      >
         <template v-slot:category="{ category, present, date }">
          <div
            v-if="present"
            class="text-center"
          >
          present
          </div>
          <div
            v-if="category=='Repairs'"
            class="text-center"
          >
          Επισκευές<br>
          Τζίρος: {{ $tocurr(filteredEvents.filter(e=> e.category == "Repairs" & e.start == date).reduce((a,b) => a + (b.repair.RepairCost ||0),0)) }} -
          Kέρδος: {{ $tocurr(filteredEvents.filter(e=> e.category == "Repairs" & e.start == date).reduce((a,b) => a + (b.repair.Profit ||0),0)) }}
          </div>
          <div
            v-if="category=='Purchases'"
            class="text-center"
          >
          Αγορές<br>
          Κόστος: {{ $tocurr(filteredEvents.filter(e=> e.category == "Purchases" & e.start == date).reduce((a,b) => a + (b.invoice.TotalValue ||0),0)) }}
          </div>
        </template>
        <template v-slot:day="{ date }">
          <v-chip>
           {{ $tocurr(events.filter(e=> e.category == "Repairs" & e.start == date).reduce((a,b) => a + (b.repair.RepairCost ||0),0)) }} -
           {{ $tocurr(events.filter(e=> e.category == "Repairs" & e.start == date).reduce((a,b) => a + (b.repair.Profit ||0),0)) }}
          </v-chip>
          </template>
      </v-calendar>

       <v-dialog
          v-model="selectedOpen"
          :close-on-content-click="false"
          :activator="selectedElement"
          min-width="350px"
          max-width="700px"
          >
          <v-card
            color="grey lighten-4"
            internal-activator
            flat
          >
            <v-toolbar
              :color="selectedEvent.color"
              dark
            >
              <v-btn
               v-if="selectedEvent.category=='Repairs'"
               :to="{name: 'edit-repair', params: {repairId: selectedEvent.repair.Id}}"
               icon>

                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
               v-if="selectedEvent.category=='Sales'"
               :to="{name: 'Invoice', params: {invoid: selectedEvent.sale.Id}}"
               icon>

                <v-icon>mdi-information</v-icon>
              </v-btn>
              <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon>
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <span v-if="selectedEvent.category=='Repairs'" v-html="selectedEvent.repair.Notes"></span>
              <span v-if="selectedEvent.category=='Appointments'" v-html="selectedEvent.details"></span>
                <invoice-summary v-if="selectedEvent.category=='Sales'" :invoiceId.sync="selectedEvent.sale.Id"/>
            </v-card-text>
            <v-card-actions>
              <v-btn
                text
                color="secondary"
                @click="selectedOpen = false"
              >
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
            v-model="dialog"
            persistent
            max-width="600px"
          >
    <v-card>
      <v-card-title>
        <span class="text-h5">Νέο Ραντεβού</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col
              cols="1"
            >
              <v-text-field
                label="ID"
                v-model="appointmentForm.Id"
                readonly
              ></v-text-field>
            </v-col>
            <v-col
              cols="10"
              sm="8"
              md="8"
            >
              <v-text-field
                label="Όνομα*"
                v-model="appointmentForm.Contact"
                required
                prepend-icon="mdi-card-account-details"
              ></v-text-field>
            </v-col>
            <v-col
              cols="5"
              sm="5"
              md="4"
            >
              <v-text-field
                label="Τηλέφωνο"
                prepend-icon="mdi-phone-classic"
                v-model="appointmentForm.Telephone"
                type="tel"
              ></v-text-field>
            </v-col>
            <v-col cols="8"
                   sm="6">
              <v-text-field
                label="Όχημα"
                v-model="appointmentForm.PlateNumber"
                prepend-icon="mdi-car"
                class="toupper"
                @input="appointmentForm.PlateNumber = appointmentForm.PlateNumber.toUpperCase()"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
            >
              <v-textarea
                label="Remarks"
                rows=3
                v-model="appointmentForm.Remarks"
                hint="Σχόλια"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-container>
        <small>* Υποχρεωτικά πεδία</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click.native="dialog = false"
        >
          Ακύρωση
        </v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click="createAppointment"
        >
          Αποθηκευση
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
    </v-sheet>
  </div>



</template>

<script>
import InvoiceSummary from '../components/InvoiceSummary.vue';
  export default {
    computed: {
        filteredEvents() {
            return this.events.filter(e => this.showCategories.includes(e.category));
        }
    },
    components: {
      InvoiceSummary
    },
    data: () => ({
      type: 'month',
      types: ['month', 'week', 'day', 'category'],
      mode: 'stack',
      modes: ['stack', 'column'],
      weekday: [0, 1, 2, 3, 4, 5, 6],
      weekdays: [
        { text: 'Sun - Sat', value: [0, 1, 2, 3, 4, 5, 6] },
        { text: 'Mon - Sun', value: [1, 2, 3, 4, 5, 6, 0] },
        { text: 'Mon - Fri', value: [1, 2, 3, 4, 5] },
        { text: 'Mon, Wed, Fri', value: [1, 3, 5] },
      ],
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      value: '',
      categories: ['Repairs', 'Sales', 'Purchases','Appointments'],
      showCategories: ['Repairs'],
      events: [],
      colors: ['indigo lighten-2', 'teal', 'cyan', 'green','maroon', 'orange','blue',],
      dialog: false,
      totalProfit: 0,
      totalSales: 0,
      totalPurch: 0,
      appointmentForm: {
        Id: null,
        DateTime:new Date(Date.now()).getTime(),
        Remarks: null,
        PlateNumber: null,
        Contact: null,
        Telephone: null,
     },
    }),

    async created () {
     await this.getEvents();
    },
    methods: {
      async getEvents ({ start, end }) {
      const events = [];
      if (this.showCategories.includes('Repairs')) {
          const repairs = await this.getRepairs({ start, end });
          events.push(...repairs);
      }
      if (this.showCategories.includes('Sales')) {
          const sales = await this.getSales({ start, end });
          events.push(...sales);
      } 
      if (this.showCategories.includes('Invoices')) {
          const invos = await this.getInvos({ start, end });
          events.push(...invos);
      }
      if (this.showCategories.includes('Appointments')) {
          const apps = await this.getApps({ start, end });
          events.push(...apps);
      }
      this.events = events;
      },
      async getRepairs({start, end}) {
       const events = []
       const response = await this.$api.get('/repairs/calendar/',
           {
            params: {
              'start-date': start.date,
              'end-date': end.date
            }
           });
        const repairs = response.data;

        for (let repair of repairs) {
            let name = 'Άγνωστο';
          if (repair.Vehicle.Owner) name = repair.Vehicle.Owner.Name;
          events.push({
            name: `${repair.Vehicle.PlateNumber} - ${name}`,
            start: repair.Date,
            color:'cyan',
            category: 'Repairs',
            timed: true,
            repair: repair,
          })
        }
        return events;

      },
      async getSales({start, end}) {
       const events = []
       const response = await this.$api.get('/invoices',
           {
             params: {
              'start-date': start.date,
              'end-date': end.date
            }
           });
        const sales = response.data;

        for (let sale of sales) {
          events.push({
            name: `${sale.DocNumber} -  ${sale.Customer?.Name}`,
            start: sale.Date,
            color: sale.Kind == 'Item' ? 'orange': 'blue lighten-3',
            category: 'Sales',
            timed: true,
            sale: sale,
          })
        }
        return events;

      },
      async getApps({start, end}) {
       const events = []
       const response = await this.$api.get('/appointments',
           {
             params: {
              'start-date': start.date,
              'end-date': end.date
            }
           });
        const sales = response.data;

        for (let sale of sales) {
        let start = new Date(sale.DateTime).getTime();
          events.push({
            name: `${sale.Id} -  ${sale.Contact}`,
            start: start,
            end: start + 3600000,
            color: 'blue lighten-3',
            category: 'Appointments',
            timed: true,
            details: sale.Remarks,
            app: sale,
          })
        }
        return events;

      },
      async getInvos({start, end}) {
       const events = []
       const response = await this.$api.get('/suppliers/invoices',
           {
             params: {
              'start-date': start.date,
              'end-date': end.date
            }
           });
        const invos = response.data;

        for (let invo of invos) {
          events.push({
            name: `${invo.DocNumber} -  ${invo.Supplier.Name.substr(0,20)}...`,
            start: invo.Date,
            color: this.colors[invo.Kind],
            category: 'Purchases',
            timed: true,
            invoice: invo,
          })
        }
        return events;
      },
      intervalClick (tms ) {
        //console.log(tms.date, this.toTime(tms), this.roundTime(this.toTime(tms)));
        let start = this.roundTime(this.toTime(tms));
        this.appointmentForm.DateTime = start;

        this.dialog = true;


      },
      toTime (tms) {
        return new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute).getTime()
      },
      roundTime (time, down = true) {
        const roundTo = 15 // minutes
        const roundDownTime = roundTo * 60 * 1000

        return down
          ? time - time % roundDownTime
          : time + (roundDownTime - (time % roundDownTime))
      },
      async createAppointment() {
        let appointment = this.appointmentForm;
        var response = await this.$api.post('/appointments/', appointment);
        if (response.status == 201) {
          appointment = response.data.Id;
          this.events.push({
            name: `${this.appointmentForm.Contact}`,
            start: this.appointmentForm.DateTime,
            end:this.appointmentForm.DateTime + 3600000,
            color:'indigo',
            category: 'Appointments',
            timed: true,
            details: this.appointmentForm.Remarks,
          })
          this.dialog = false;
        }
      },
       showEvent ({ nativeEvent, event }) {
        const open = () => {
          this.selectedEvent = event
          this.selectedElement = nativeEvent.target
          requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
        }

        if (this.selectedOpen) {
          this.selectedOpen = false
          requestAnimationFrame(() => requestAnimationFrame(() => open()))
        } else {
          open()
        }

        nativeEvent.stopPropagation()
      },
      getEventColor (event) {
        return event.color
      },
      viewDay ({ date }) {
        this.focus = date
        this.type = 'category'
      },
      rnd (a, b) {
        return Math.floor((b - a + 1) * Math.random()) + a
      },
    },
  }
</script>
